import App from './App.svelte';
const { widgetOptions } = window;
// If widgetOptions exist - we'll create widget at website
if (widgetOptions) {
    widgetOptions['url'] = generateUrl(widgetOptions.domain, widgetOptions.isLocal);
    widgetOptions['isVideoAvatar'] = isVideoAvatar(widgetOptions.avatar);
    widgetOptions['avatar'] = avatarLink(widgetOptions.avatar, widgetOptions.url);
}
else {
    throw new Error('widgetOptions not defined!');
}
function generateUrl(domain, isLocal = false) {
    return `${isLocal ? 'http://' : 'https://'}${domain}`;
}
function avatarLink(avatarLink, url) {
    if (avatarLink) {
        return `${url}${avatarLink}`;
    }
    else {
        return `${url}/img/all_transparent_logo.png`;
    }
}
function isVideoAvatar(avatarLink) {
    if (avatarLink) {
        return avatarLink.startsWith('/uploads/video/');
    }
    else {
        return false;
    }
}
// Get HTML head element
const head = document.getElementsByTagName('HEAD')[0];
const link = document.createElement('link');
link.rel = 'stylesheet';
link.type = 'text/css';
// Make sure url for load styles
const styleUrl = widgetOptions.isLocal
    ? 'http://localhost:5000/build/bundle.css'
    : `${widgetOptions.url}/widget/style.css`;
link.href = styleUrl;
head.appendChild(link);
const app = new App({
    target: document.body,
    props: {
        widgetOptions
    }
});
export default app;
